import React from 'react';
import {Col} from 'react-bootstrap';
import {HeaderStyle, TextStyle} from '../assets/css/Styles';

/**
 *
 * @param {Object} props - props for each header nav link
 * @return {Component} each header nav link container
 */
export default function EachHeaderText({...props}) {
  return (
    <Col style={HeaderStyle.eachInactiveLinkDiv}>
      <span style={TextStyle.normalTxt2}>{props.headerLinkName}</span>
    </Col>
  );
}
